<template>
  <div class="content-wrappper ">
    <div class="cart-main" :class="Object.keys(this.servicesInCart).length === 0 && 'no-items-in-cart-height'">
      <div class="col-md-12 col-xs-12 col-sm-12 cart-header d-flex justify-content-between">
        <div class="d-flex align-items-center col-gap-44">
          <img src="static/images/icons/cartIcon.svg" class="" />
          <span v-if="Object.keys(this.servicesInCart).length === 0 " class="items-text">0 {{ $t("itemsLabel") }}</span>
          <span v-else class="items-text">{{(this.servicesInCart.users_count + (this.servicesInCart.products_available / 5))}} {{ $t("itemsLabel") }}</span>
        </div>
        <div class="d-flex align-items-center col-gap-80" v-if="Object.keys(this.servicesInCart).length">
          <span class="total-text">Total: {{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(getTotalPrice()) }} </span>
          <span class="cursor-pointer" @click="close()"><img src="static/images/icons/cart_close_icon.svg" height="19px" width="19px" /> </span>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 col-sm-12 cart-wrapper">

        <div class="col-xs-12 col-md-12 col-sm-12 tabs-main ">
          <div class="col-xs-3 col-md-3 col-sm-3 pr-2">
            <div
              :class="
                activeHeaderClass === 'Selected Services'
                  ? 'active_progress_bar'
                  : 'visited_progress_bar'
              "
            >
              <div
                class="center tabs-text"
                :class="activeHeaderClass === 'Selected Services' ? 'active_text' : 'visited_text'"
              >
                {{ $t("selectedServices") }}
              </div>
            </div>
          </div>

           <div class="col-xs-3 col-md-3 col-sm-3 pr-2 tab-stepper">
            <div
              :class="
                activeHeaderClass === 'PaymentMethod'
                  ? 'active_progress_bar'
                  : haveVisitedPaymentPage
                  ? 'visited_progress_bar'
                  : 'inactive_progress_bar'
              "
            >
              <div
                class="center tabs-text"
                :class="activeHeaderClass === 'PaymentMethod' ? 'active_text' : haveVisitedPaymentPage ?'visited_text' : 'active_text'"
              >
                {{$t('paymentMethod')}}
              </div>
            </div>
          </div>
          <div class="col-xs-3 col-md-3 col-sm-3 pr-2 tab-stepper">
            <div
              :class="
                activeHeaderClass === 'BillingInfo'
                  ? 'active_progress_bar'
                  : haveVisitedBillingInfoPage
                  ? 'visited_progress_bar'
                  : 'inactive_progress_bar'
              "
            >
              <div
                class="center tabs-text"
                :class="activeHeaderClass === 'BillingInfo' ? 'active_text' : haveVisitedBillingInfoPage ? 'visited_text' : 'active_text'"
              >
                {{$t('billingInformation')}}
              </div>
            </div>
          </div>

          <div class="col-xs-3 col-md-3 col-sm-3 tab-stepper">
            <div
              :class="
                activeHeaderClass === 'Confirmation'
                  ? 'active_progress_bar'
                  : isVisitedConfirmPage
                  ? 'visited_progress_bar'
                  : 'inactive_progress_bar'
              "
            >
              <div
                class="center tabs-text active_text"
              >
                {{ $t("confirmation") }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="Object.keys(this.servicesInCart).length > 0">
        <div class="col-md-12 col-xs-12 plr-37" v-if="activeHeaderClass === 'Selected Services'">
          <div class="services">
            <div
              class="  d-flex justify-content-between service-title"
              v-if="this.servicesInCart.subscriptionId === 2"
            >
              <div class="d-flex align-items-center">
                <div v-if="getSubscriptionDetails()">
                  <span class="items-text ">{{ $t("proServices") }}</span>
                </div>
                <div v-else>
                  <span class="items-text ">{{ $t("additionalPurchase") }}</span>
                </div>
              </div>
              <div class="d-flex col-gap-24 " v-if="getSubscriptionDetails()">
                <span class="price-text ">{{ $t("basePrice") }}:  <span class="price-details">{{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(1399) }} {{ $t("perYear") }}</span></span>
              </div>
            </div>
            <div class="  d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <span class="services-text"></span>
              </div>
              <div class="d-flex align-items-center col-gap-24" :class="{'pt-16': getSubscriptionDetails()}">
                <button
                  type="button"
                  class="remove_cart_button"
                  @click="removeFromCart(servicesInCart.marketId)"
                >
                  {{ $t("removeFromCart") }}
                </button>
              </div>
            </div>
            <div v-if="getSubscriptionDetails()">
              <div class="pb-8">
                <span class="services-text">{{ $t("servicesIncluded") }}:</span>
              </div>
              <div>
                <div>
                  <ul class="d-flex mb-0">
                    <li class="li-tag-data primary-default-text-color fw-400">{{ $t("portfolioService") }}</li>
                    <span class="pl-57"><li class="li-tag-data primary-default-text-color fw-400">{{ $t("providersService") }}</li></span>
                  </ul>
                </div>
                <div>
                  <ul class="d-flex pt-12">
                    <li class="li-tag-data primary-default-text-color fw-400">{{ $t("regulatoryService") }}</li>
                    <span class="pl-69" :class="$i18n.locale === 'Portuguese' && 'ml-11'"><li class="li-tag-data primary-default-text-color fw-400">{{ $t("evidenceService") }}</li></span>
                  </ul>
                </div>
              </div>
            </div>
            <div v-if="getSubscriptionDetails()">
              <hr class="services-divider" />
            </div>
            <div class="pl-20 pt-22">
            <li class="primary-default-text-color fw-600 additionalServicesListHeaders"><img src="/static/images/icons/emergo_list_bullet_ellipse.svg"/>{{$t('totalCertificates')}}: {{servicesInCart.products_available === null ? 0 :servicesInCart.products_available / 5}}</li>
            <div class="d-flex pl-32 pt-24">
              <div class="checkbox-wrapper">
                <label class="custom-checkbox" :class="{'disable-content': getSubscriptionDetails()}">
                  <input type="checkbox" :class="`checkbox ${roleId !== 1 ? 'cursor-not-allowed' : ''}`" v-model="selectCertificates" @change="updateServices()" :disabled="roleId !== 1" />
                  <span :class="`select-check ${roleId !== 1 ? 'cursor-not-allowed' : ''}`"></span>
                </label>
              </div>
              <p class="ml-10 emergo-brand-black fw-400" v-if="getSubscriptionDetails()">{{$t('addAdditionalCertificate1')}}</p>
              <p class="ml-10 emergo-brand-black fw-400" v-else>{{$t('addAdditionalCertificate2')}}</p>
              </div>
              <div class="d-flex pt-16-pl-70 align-items-center" :class="{'disable-content': !this.selectCertificates}">
                <p class="m-0 div-center pr-34 primary-default-text-color fw-400">{{$t('SelectNumberOf')}}<br/> {{$t('SelectNumberOfDesc')}}</p>
                <img @click="changeCertificatesCount('decrease')" :class="{'disable-content': getSubscriptionDetails() && servicesInCart.products_available / 5 === 1}" src="/static/images/icons/marketplaceMinusIcon.svg" alt="minus" />
                <input type="text" :value="servicesInCart.products_available === null ? 0 : servicesInCart.products_available / 5" class="ml-16 dimensions cursor-disabled" />
                <img @click="changeCertificatesCount('increase')" class="ml-16" src="/static/images/icons/marketplacePlusIcon.svg" alt="plus" />
                <p class="pl-25 m-0 div-center primary-default-text-color fw-400">Total: {{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(servicesInCart.certificates_purchase_amount === null ? 0 : servicesInCart.certificates_purchase_amount) }}</p>
              </div>
            </div>
          <div>
            <hr class="hr-line" />
          </div>
            <div class="pl-20 pt-22">
            <li class="primary-default-text-color fw-600 additionalServicesListHeaders"><img src="/static/images/icons/emergo_list_bullet_ellipse.svg"/>{{$t('totalUserIncluded')}}: {{servicesInCart.users_count === null ? 0 : servicesInCart.users_count}}</li>
            <div class="d-flex pl-32 pt-24">
              <div class="checkbox-wrapper">
                <label class="custom-checkbox" :class="{'disable-content': getSubscriptionDetails()}">
                  <input type="checkbox" :class="`checkbox ${roleId !== 1 ? 'cursor-not-allowed' : ''}`" v-model="selectUsers" @change="updateServices()" :disabled="roleId !== 1" />
                  <span :class="`select-check ${roleId !== 1 ? 'cursor-not-allowed' : ''}`"></span>
                </label>
              </div>
              <p class="ml-10 emergo-brand-black fw-400" v-if="getSubscriptionDetails()">{{$t('addAdditional1')}}</p>
              <p class="ml-10 emergo-brand-black fw-400" v-else>{{$t('addAdditional2')}}</p>
            </div>
            <div class="d-flex pt-16-pl-70 align-items-center" :class="{'disable-content': !this.selectUsers}">
              <p class="m-0 div-center primary-default-text-color fw-400" :class="$i18n.locale === 'English' ? 'pr-74' : 'pr-56'">{{$t('selectNumber')}}<br/> {{$t('selectNumberDesc')}}</p>
              <img @click="changeUsersCount('decrease')" :class="{'disable-content': getSubscriptionDetails() && servicesInCart.users_count === 1}" src="/static/images/icons/marketplaceMinusIcon.svg" alt="minus" />
              <input type="text" :value="servicesInCart.users_count === null ? 0 : servicesInCart.users_count" class="ml-16 dimensions cursor-disabled" />
              <img @click="changeUsersCount('increase')" class="ml-16" src="/static/images/icons/marketplacePlusIcon.svg" alt="plus" />
              <p class="pl-25 m-0 div-center primary-default-text-color fw-400">Total: {{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(servicesInCart.users_purchase_amount === null ? 0 : servicesInCart.users_purchase_amount)}}</p>
            </div>
          </div>
          </div>
        </div>

        <div class="col-md-12 col-xs-12 plr-55" v-if="activeHeaderClass === 'PaymentMethod'">
          <div>
            <div v-for="(method, index) in paymentOptions" :key="index">
              <div class="payment-methods">
                <label class="mb-0">
                  <input class="radio-btn" type="radio" :value="method.id" v-model="paymentMethod" @change="selectedPaymentMethod(method)" />
                  <span class="payment-method">{{method.mode}}</span>
                </label>
                <!-- <div class="cc-card" v-if="method.id === 1 && paymentMethod === 1">
                  <div class="row pt-12">
                    <div class="col-xs-12 col-gap-56">
                      <div class="col-xs-6 form-group pl-7">
                        <label class="field_head">{{ $t('nameOnCard') }}</label>
                        <input
                          class="form-control comn_border"
                          type="text"
                          :placeholder="$t('nameOnCard')"
                          maxlength="50"
                          v-model.trim="creditCardDetails.name"
                          :class="$v.creditCardDetails.name.$error ? 'invalid-border' : ''"
                          @blur="$v.creditCardDetails.name.$touch()"
                        />
                        <div v-if="$v.creditCardDetails.name.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.creditCardDetails.name.required"
                          >{{$t('completeRequiredField')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="!$v.creditCardDetails.name.minLength"
                          >{{$t('min2CharactersRequired')}}</div>
                        </div>
                      </div>
                      <div class="col-xs-6 form-group">
                        <label class="field_head">{{ $t('cardNumber') }}</label>
                        <input
                          class="form-control comn_border"
                          type="text"
                          :placeholder="$t('cardNumber')"
                          maxlength="16"
                          required
                          v-model.trim="creditCardDetails.card_number"
                          :class="$v.creditCardDetails.card_number.$error ? 'invalid-border' : ''"
                          @blur="$v.creditCardDetails.card_number.$touch()"
                        />
                        <div v-if="$v.creditCardDetails.card_number.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.creditCardDetails.card_number.required"
                          >{{$t('completeRequiredField')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="!$v.creditCardDetails.card_number.isNumber"
                          >{{$t('enterOnlyNumbers')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="!$v.creditCardDetails.card_number.minLength"
                          >{{$t('min16CharactersRequired')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="!$v.creditCardDetails.card_number.maxLength"
                          >{{$t('max16Characters')}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-gap-56">
                      <div class="col-xs-6 form-group pl-7">
                        <label class="field_head">{{ $t('cardType') }}</label>
                        <multiselect
                          openDirection="below"
                          :placeholder="$t('cardType')"
                          :show-labels="false"
                          :allow-empty="false"
                          class="product-class-ellipsis multiselect-single-dropdown"
                          :searchable="false"
                          :options="cardTypes.map(type => type.name)"
                          v-model="creditCardDetails.card_type"
                          :class="$v.creditCardDetails.card_type.$error ? 'invalid-border' : ''"
                        />
                        <div v-if="$v.creditCardDetails.card_type.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.creditCardDetails.card_type.required"
                          >{{$t('completeRequiredField')}}</div>
                        </div>
                      </div>
                      <div class="col-xs-6 form-group">
                        <label class="field_head">{{ $t('amount') }}</label>
                        <input
                          class="form-control comn_border"
                          type="text"
                          :placeholder="$t('amount')"
                          maxlength="16"
                          v-model.trim="creditCardDetails.amount"
                          :class="$v.creditCardDetails.amount.$error ? 'invalid-border' : ''"
                          @blur="$v.creditCardDetails.amount.$touch()"
                          disabled
                        />
                        <div v-if="$v.creditCardDetails.amount.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.creditCardDetails.amount.required"
                          >{{$t('completeRequiredField')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="!$v.creditCardDetails.amount.minLength"
                          >{{$t('min2CharactersRequired')}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 pl-22 expiation-date">
                      {{ $t('expirationDate') }}:
                    </div>
                    <div class="col-xs-12">
                      <div class="col-xs-3 form-group pl-7 pr-46">
                        <label class="field_head">{{ $t('month') }}</label>
                        <multiselect
                          openDirection="below"
                          :placeholder="$t('month')"
                          :show-labels="false"
                          :allow-empty="false"
                          class="product-class-ellipsis multiselect-single-dropdown"
                          :searchable="true"
                          :options="monthList"
                          v-model="creditCardDetails.expiry_month"
                          :class="$v.creditCardDetails.expiry_month.$error ? 'invalid-border' : ''"
                        >
                        <span slot="noResult">{{ $t('noMatchingData') }}</span>
                        </multiselect>
                        <div v-if="$v.creditCardDetails.expiry_month.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.creditCardDetails.expiry_month.required"
                          >{{$t('completeRequiredField')}}</div>
                        </div>
                      </div>
                      <div class="col-xs-3 form-group pl-7 pr-46">
                        <label class="field_head">{{ $t('year') }}</label>
                        <multiselect
                          openDirection="below"
                          :show-labels="false"
                          class="product-class-ellipsis multiselect-single-dropdown"
                          :placeholder="$t('year')"
                          v-model="creditCardDetails.expiry_year"
                          :class="$v.creditCardDetails.expiry_year.$error ? 'invalid-border' : ''"
                          :options="yearsList"
                          :searchable="true"
                          >
                          <span slot="noResult">{{ $t('noMatchingData') }}</span>
                        </multiselect>
                        <div v-if="$v.creditCardDetails.expiry_year.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.creditCardDetails.expiry_year.required"
                          >{{$t('completeRequiredField')}}</div>
                        </div>
                      </div>
                      <div class="col-xs-6 form-group pl-40">
                        <label class="field_head">CVC</label>
                        <input
                          class="form-control comn_border"
                          type="text"
                          placeholder="CVC"
                          maxlength="3"
                          v-model.trim="creditCardDetails.card_cvc"
                          :class="$v.creditCardDetails.card_cvc.$error ? 'invalid-border' : ''"
                          @blur="$v.creditCardDetails.card_cvc.$touch()"
                        />
                        <div v-if="$v.creditCardDetails.card_cvc.$error">
                          <div
                            class="custom-error-class"
                            v-if="!$v.creditCardDetails.card_cvc.required"
                          >{{$t('completeRequiredField')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="!$v.creditCardDetails.card_cvc.minLength"
                          >{{$t('min3CharactersRequired')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="!$v.creditCardDetails.card_cvc.maxLength"
                          >{{$t('max3Characters')}}</div>
                          <div
                            class="custom-error-class"
                            v-else-if="!$v.creditCardDetails.card_cvc.isNumber && $v.creditCardDetails.card_cvc.$error"
                          >{{$t('enterOnlyNumbers')}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-xs-12 plr-45" v-if="activeHeaderClass === 'BillingInfo'">
          <div class="billing-info">
            <p class="items-text">{{$t('billingContactInfo')}}</p>
            <div class="row pt-12">
              <div class="col-xs-12 col-gap-56">
                <div class="col-xs-6 form-group pl-7">
                  <label class="field_head">{{$t('firstName')}}</label>
                  <input
                    class="form-control comn_border"
                    type="text"
                    :placeholder="$t('firstNamePlaceholder')"
                    maxlength="35"
                    v-model.trim="userData.first_name"
                    :class="$v.userData.first_name.$error ? 'invalid-border' : ''"
                    @blur="$v.userData.first_name.$touch()"
                  />
                  <div v-if="$v.userData.first_name.$error">
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.first_name.required"
                    >{{$t('completeRequiredField')}}</div>
                    <div
                      class="custom-error-class"
                      v-else-if="!$v.userData.first_name.minLength"
                    >{{$t('min2CharactersRequired')}}</div>
                  </div>
                </div>
                <div class="col-xs-6 form-group">
                  <label class="field_head">{{$t('lastName')}}</label>
                  <input
                    class="form-control comn_border"
                    type="text"
                    :placeholder="$t('lastNamePlaceholder')"
                    maxlength="30"
                    v-model.trim="userData.last_name"
                    :class="$v.userData.last_name.$error ? 'invalid-border' : ''"
                    @blur="$v.userData.last_name.$touch()"
                  />
                  <div v-if="$v.userData.last_name.$error">
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.last_name.required"
                    >{{$t('completeRequiredField')}}</div>
                    <div
                      class="custom-error-class"
                      v-else-if="!$v.userData.last_name.minLength"
                    >{{$t('min2CharactersRequired')}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-gap-56">
                <div class="col-xs-6 form-group pl-7">
                  <label class="field_head">{{$t('emailAddress')}}</label>
                  <input
                    class="form-control comn_border"
                    type="text"
                    :class="{'invalid-border': $v.userData.email.$error || displayEmailErrorMsg }"
                    :placeholder="$t('emailPlaceholder')"
                    maxlength="65"
                    v-model.trim="userData.email"
                    @blur="emailVal()"
                  />
                  <div v-if="!loaderStatus && $v.userData.email.$error">
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.email.required"
                    >
                      {{$t('completeRequiredField')}}
                    </div>
                  </div>
                  <div v-else-if="displayEmailErrorMsg" class="custom-error-class">
                    {{$t('invalidEmailEntry')}}
                  </div>
                </div>
                <div class="col-xs-6 form-group">
                  <label class="field_head">{{$t('phoneNumber')}}</label>
                  <input
                    class="form-control comn_border"
                    type="text"
                    :placeholder="$t('phoneNumberPlaceholder')"
                    size="15"
                    maxlength="20"
                    v-model.trim="userData.phone"
                    :class="$v.userData.phone.$error ? 'invalid-border' : ''"
                    @blur="$v.userData.phone.$touch()"
                  />
                  <div v-if="$v.userData.phone.$error">
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.phone.required"
                    >{{$t('completeRequiredField')}}</div>
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.phone.isNumber && $v.userData.phone.$error"
                    >{{$t('enterOnlyNumbers')}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-12">
              <hr class="divider-line" />
            </div>

            <div class="row">
              <div class="col-xs-12 col-gap-56">
                <div class="col-xs-6 form-group pl-7">
                  <p class="align-left mb-0 ft-14 field_head asterisk">{{$t('cnpj')}}</p>
                  <div class="form-group" :class="$v.userData.cnpj.$error ||cnpjValidation||isValidCnpj==='invalid' ? 'mb-12':''">
                    <input
                      class="form-control comn_border"
                      v-model.trim="userData.cnpj"
                      :class="$v.userData.cnpj.$error||cnpjValidation||isValidCnpj==='invalid' ? 'invalid-border':''"
                      type="text"
                      :placeholder="$t('cnpjPlaceholder')"
                      :disabled="isFailure"
                      @input="cnpjMasking(userData.cnpj)"
                      @blur="validateCnpj()"
                      maxlength="18"
                    />
                    <div v-if="$v.userData.cnpj.$error">
                      <div
                        class="custom-error-class"
                        v-if="!$v.userData.cnpj.required"
                      >
                        {{$t('completeRequiredField')}}</div>
                    </div>
                    <div v-else-if="cnpjValidation" class="custom-error-class">
                      {{$t('enterValidCnpj')}}
                    </div>
                    <div
                        class="custom-error-class"
                        v-else-if="userData.cnpj&&isValidCnpj==='invalid'"
                      >
                          {{$t('invalidCnpjNumber')}}</div>
                      <!-- <div
                        class="custom-success-class"
                        v-else-if="cnpj&&isValidCnpj==='valid'"
                      > {{$t('validCnpjNumber')}}</div> -->
                  </div>
                </div>
                <div class="col-xs-6 form-group">
                  <label class="field_head">{{$t('streetAddress')}}</label>
                  <input
                    class="form-control comn_border"
                    type="text"
                    :placeholder="$t('streetAddressPlaceholder')"
                    v-model.trim="userData.street_address"
                    size="60"
                    maxlength="500"
                    :class="$v.userData.street_address.$error ? 'invalid-border' : ''"
                    @blur="$v.userData.street_address.$touch()"
                  />
                  <div v-if="$v.userData.street_address.$error">
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.street_address.required"
                    >{{$t('completeRequiredField')}}</div>
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.street_address.isAllowedCharacters && $v.userData.street_address.$error"
                    >{{ specialCharacterErrMsg }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-2">
              <div class="col-xs-12 col-gap-56">
                <div class="col-xs-6 pl-7 form-group">
                  <label class="field_head">{{$t('addressNumber')}}</label>
                  <input
                    class="form-control comn_border"
                    type="text"
                    :placeholder="$t('addressNumberPlaceholer')"
                    v-model.trim="userData.address_number"
                    :class="$v.userData.address_number.$error ? 'invalid-border' : ''"
                    @blur="$v.userData.address_number.$touch()"
                  />
                  <div v-if="$v.userData.address_number.$error">
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.address_number.required"
                    >{{$t('completeRequiredField')}}</div>
                    <div
                      class="custom-error-class"
                      v-else-if="!$v.userData.address_number.maxLength"
                    >{{$t('max10Characters')}}</div>
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.address_number.isNumber && $v.userData.address_number.$error"
                    >{{$t('enterOnlyNumbers')}}</div>
                  </div>

                </div>
                <div class="col-xs-6 form-group">
                  <label class="field_head">{{$t('city')}}</label>
                  <input
                    class="form-control comn_border"
                    type="text"
                    :placeholder="$t('cityPlaceholder')"
                    size="60"
                    maxlength="50"
                    v-model.trim="userData.card_city"
                    :class="$v.userData.card_city.$error ? 'invalid-border' : ''"
                    @blur="$v.userData.card_city.$touch()"
                  />
                  <div v-if="$v.userData.card_city.$error">
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.card_city.required"
                    >{{$t('completeRequiredField')}}</div>
                    <div
                      class="custom-error-class"
                      v-if="!$v.userData.card_city.minLength"
                    >{{$t('min3CharactersRequired')}}</div>
                    <div
                      class="custom-error-class"
                      v-else-if="!$v.userData.card_city.isAllowedCharacters"
                    >{{ specialCharacterErrMsg }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pt-5">
              <div class="col-xs-12 col-gap-56">
                <div class="col-xs-6 p-0 pl-7">
                  <div class="col-xs-6 form-group pr-12 pl-0">
                    <label class="field_head">{{$t('state')}}</label>
                    <input
                      class="form-control comn_border"
                      type="text"
                      :placeholder="$t('statePlaceholder')"
                      size="60"
                      maxlength="50"
                      v-model.trim="userData.card_state"
                      :class="$v.userData.card_state.$error ? 'invalid-border' : ''"
                      @blur="$v.userData.card_state.$touch()"
                    />
                    <div v-if="$v.userData.card_state.$error">
                      <div
                        class="custom-error-class"
                        v-if="!$v.userData.card_state.required"
                      >{{$t('completeRequiredField')}}</div>
                      <div
                        class="custom-error-class"
                        v-if="!$v.userData.card_state.isAllowedCharacters && $v.userData.card_state.$error"
                      >{{ specialCharacterErrMsg }}</div>
                      <div
                        class="custom-error-class"
                        v-if="!$v.userData.card_state.isText && $v.userData.card_state.$error"
                      >{{$t('invalidFormat')}}</div>
                    </div>
                  </div>
                  <div class="col-xs-6 form-group pl-12">
                    <label class="field_head">{{$t('postCode')}}</label>
                    <input
                      class="form-control comn_border"
                      type="text"
                      :placeholder="$t('postCodePlaceholder')"
                      maxlength="15"
                      v-model.trim="userData.card_postal"
                      :class="$v.userData.card_postal.$error ? 'invalid-border' : ''"
                      @blur="$v.userData.card_postal.$touch()"
                    />
                    <div v-if="$v.userData.card_postal.$error">
                      <div
                        class="custom-error-class"
                        v-if="!$v.userData.card_postal.required"
                      >{{$t('completeRequiredField')}}</div>
                      <div
                        class="custom-error-class"
                        v-if="!$v.userData.card_postal.minLength"
                      >{{$t('min2CharactersRequired')}}.</div>
                      <div
                        class="custom-error-class"
                        v-else-if="!$v.userData.card_postal.isPostalCode && userData.card_postal"
                      >{{$t('validZipRequired')}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-6 form-group">
                  <label class="field_head">{{$t('country')}}</label>
                  <multiselect
                    openDirection="above"
                    :searchable="true"
                    class="product-class-ellipsis multiselect-single-dropdown"
                    :placeholder="$t('selectCountry')"
                    label="country_name"
                    v-model="userData.country_name"
                    :show-labels="false"
                    :options="countryList.map(type => type.country_name)"
                    :custom-label="opt => customLabels(opt)"
                  >
                  <span slot="noResult">{{ $t('noElementsFound') }}</span>
                  </multiselect>
                  <div v-if="$v.userData.country_name.$error">
                    <div
                      class="custom-error-class pt-48"
                      v-if="!$v.userData.country_name.required && $v.userData.country_name.$error"
                    >{{$t('completeRequiredField')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-xs-12 plr-55" v-if="activeHeaderClass === 'Confirmation'">
          <div class="confirmation-page">
            <div class="confirmation-header d-flex justify-content-between">
              <span class="selected-text">{{ $t("selectedText") }}</span>
              <!-- <span class="edit" @click="goToServicesPage()">{{ $t("edit") }}</span> -->
            </div>
            <hr class="upper-line" />

            <div class="pl-18 pr-26" v-if="servicesInCart">
               <div class="service-title items-text pb-16 d-flex justify-content-between">
                <div  v-if="servicesInCart.subscriptionId === 2">
                  <div v-if="getSubscriptionDetails()">
                    <span class="items-text ">{{ $t("proServices") }}</span>
                  </div>
                  <div v-else>
                    <span class="items-text ">{{ $t("additionalPurchase") }}</span>
                  </div>
                </div>
                <div class="d-flex col-gap-24 " v-if="getSubscriptionDetails()">
                    <span class="price-text ">{{$t('basePrice')}}: <span class="price-details"> {{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(1399) }} {{$t('perYear')}}</span></span>
                </div>
              </div>
              <div class="services-body">
                <div class="d-flex justify-content-between pt-8 pb-16" v-if="getSubscriptionDetails()">
                  <span class="services-text">{{ $t("servicesIncluded") }}:</span>
                </div>
                <div v-if="getSubscriptionDetails()">
                  <div>
                    <ul class="d-flex mb-0">
                      <li class="li-tag-data">{{ $t("portfolioService") }}</li>
                      <span class="pl-57"><li class="li-tag-data">{{ $t("providersService") }}</li></span>
                    </ul>
                  </div>
                  <div>
                    <ul class="d-flex pt-16">
                      <li class="li-tag-data">{{ $t("regulatoryService") }}</li>
                      <span class="pl-69" :class="$i18n.locale === 'Portuguese' && 'ml-11'"><li class="li-tag-data">{{ $t("evidenceService") }}</li></span>
                    </ul>
                  </div>
                </div>
                <div class="pt-20">
                  <span class="services-text">{{ $t("confirmPurchase") }}:</span>
                  <ul>
                      <span class="pl-57">
                        <li class="li-tag-data" v-if="servicesInCart.products_available">
                          <div class="d-flex justify-content-between">
                          <div>
                            <span class="selected-user-certificate">{{ $t("totalCertificatePackIncluded") }}:</span> {{servicesInCart.products_available === null ? 0 :servicesInCart.products_available / 5}} {{ $t("certificatePrice") }}
                          </div>
                          <div class="text-bold">{{ $t("price") }}: {{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(servicesInCart.certificates_purchase_amount) }}</div>
                        </div>
                        </li>

                        <li class="li-tag-data pt-10" v-if="servicesInCart.users_count">
                          <div class="d-flex justify-content-between">
                          <div>
                          <span class="selected-user-certificate">{{$t('totalUserIncluded')}}:</span> {{servicesInCart.users_count === null ? 0 : servicesInCart.users_count}} {{ $t("userPrice") }}
                          </div>
                          <div class="text-bold">{{ $t("price") }}: {{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(servicesInCart.users_purchase_amount) }}</div>
                        </div>
                        </li>
                      </span>
                    </ul>
                </div>
              </div>
             </div>

            <div>
              <p class="billing-info-header">{{$t('billingInformation')}}</p>
              <hr class="upper-line" />
              <div class="entered-data pl-16">
                <p class="m-0">{{getUserData.first_name}} {{getUserData.last_name}}</p>
                <p class="m-0">{{getUserData.email}}</p>
                <p class="m-0">{{getUserData.phone}}</p>
                <p class="m-0">{{ getUserData.cnpj }}</p>
                <p class="m-0 street_address">{{getUserData.street_address}}</p>
                <p class="m-0">{{ getUserData.address_number }}</p>
                <p class="m-0">{{getUserData.card_city}}, {{getUserData.card_state}}</p>
                <p class="m-0">{{getUserData.card_postal}}</p>
                <p class="m-0">{{getUserData.country_name}}</p>
              </div>
              <div class="d-flex">
                <div class="col-xs-6 billing-desc">
                  {{$t('paymentMethod')}}
                </div>
                <div class="col-xs-6 d-flex justify-content-end pr-6">
                  <!-- <span class="pr-26 billing-desc">{{$t('invoiceNo')}}</span> -->
                  <span class="billing-desc">{{payment_method_name}}<span v-if="payment_method_id === 1"> No <span class="pl-24">XXXXXXXXXXXX{{ creditCardDetails.card_number.substr(-4) }}</span></span></span>
                </div>
              </div>
            </div>
            <hr class="divider-line-two" />
            <div class="d-flex">
              <div class="col-xs-6 total"><span v-if="$i18n.locale === 'Portuguese'">Valor total a pagar</span><span v-else>Total Payable Amount</span></div>
              <div class="d-flex col-xs-6 justify-content-end billing-desc pr-6">{{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(getTotalPrice()) }}</div>
            </div>
          </div>
        </div>
        </div>
        <div class="col-md-12 col-xs-12 col-sm-12 no-items" v-else >{{ $t('noItems') }}</div>
      </div>
      <div style="clear:both"></div>
    </div>
    <div class="footer d-flex col-xs-12 col-sm-12 justify-content-end d-flex-sm-end pr-0" v-if="Object.keys(this.servicesInCart).length > 0">
      <div class="col-sm-6">
        <button type="button" class="back_button" @click="goBack()">{{ $t("back") }}</button>
      </div>
      <div class="col-sm-6 pr-0 col-gap-24 d-flex buttons">
        <button type="button" class="btn cancel_button" @click="cancel()">{{ $t("cancel") }}</button>
        <button
          v-if="activeHeaderClass === 'Selected Services'|| activeHeaderClass === 'PaymentMethod' || activeHeaderClass === 'BillingInfo'"
          type="button"
          class="btn continue_button w-112"
          :disabled="disableContinue()"
          @click="goToNextPage()"
        >
          {{ $t("continue") }}
        </button>
        <button v-else-if="[1,2,3].includes(payment_method_id)" type="button" class="btn continue_button w-103" @click="showCheckout()">
          {{ $t("checkout") }}
        </button>
        <button v-else type="button" class="btn continue_button w-103" @click="confirm()">
          {{ $t("confirm") }}
        </button>
      </div>
    </div>
    <subscription-popup/>
    <checkout-popup :totalPrice="getTotalPrice()" :paymentType="payment_method_name" :paymentId="payment_method_id" :creditCardDetails="creditCardDetails" @submit="confirm"/>
    <confirm-payment-popup v-if="paymentDetails" :paymentDetails="paymentDetails"/>
    <pix-popup v-if="paymentDetails" :paymentDetails="paymentDetails" @proceedPix="proceedPix"/>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import * as moment from 'moment';
import $ from 'jquery';
import { isValidCNPJ } from '@brazilian-utils/brazilian-utils';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import {
  isNumber,
  isAllowedCharacters,
  isPostalCode,
  isText
} from '../Register/validator';
import {
  checkCnpj,
} from '../../apis/register';
import EventBus from '../../utils/event-bus';
import {
  getServicesInCart,
  removeFromCartApi,
  addToConfirm,
  cartPayment,
  finalCartConfirm,
} from '../../apis/marketPlace';
import { updateBillingInfo } from '../../apis/psm';
import CheckoutPopup from './CheckoutPopup.vue';
import ConfirmPaymentPopup from './ConfirmPaymentPopup.vue';
import PixPopup from './PixPopup.vue';
import SubscriptionPopup from '../Registrations/SubscriptionPopup.vue';
import Loader from '../UIComponents/Loader.vue';
import { getAllCountries } from '../../apis/countriesList';
import { getSubscriptions } from '../../apis/registrations';

export default {
  components: {
    SubscriptionPopup, Loader, CheckoutPopup, ConfirmPaymentPopup, PixPopup
  },
  data() {
    return {
      selectUsers: '',
      selectCertificates: '',
      roleId: '',
      checkForEmptyOrNullValues: '',
      displayEmailErrorMsg: false,
      specialCharacterErrMsg: 'The following characters are not allowed: * ? < > ! @ # $ “ % ^',
      paymentOptions: [],
      paymentMethod: '',
      isValidCnpj: '',
      cnpjValidation: false,
      isFailure: false,
      userData: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        cnpj: '',
        street_address: '',
        address_number: '',
        card_city: '',
        card_state: '',
        card_postal: '',
        country_name: '',
      },
      getUserData: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        street_address: '',
        address_number: '',
        card_city: '',
        card_state: '',
        card_postal: '',
        country_name: '',
      },
      creditCardDetails: {
        name: '',
        card_number: '',
        card_type: '',
        amount: '',
        expiry_month: '',
        expiry_year: '',
        card_cvc: ''
      },
      cardTypes: [
        {
          id: 1,
          name: 'Visa',
          type: 'VISA'
        },
        {
          id: 2,
          name: 'Master',
          type: 'MASTER'
        }
      ],
      monthList: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      yearsList: [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032],
      payment_method_id: '',
      payment_method_name: '',
      payment_method_value: '',
      update_type: 'payment_billing_page',
      id: null,
      servicesInCart: {},
      countryList: [],
      isVisitedConfirmPage: false,
      haveVisitedPaymentPage: false,
      haveVisitedBillingInfoPage: false,
      headerTabOptions: ['Selected Services', 'Confirmation'],
      activeHeaderClass: 'Selected Services',
      payPerUse: '',
      numberOfProducts: '',
      showError: false,
      redirectTo: '',
      disableProducts: true,
      loaderStatus: false,
      subscriptions: [],
      paymentDetails: {},
    };
  },
  validations: {
    userData: {
      first_name: {
        minLength: minLength(2),
        required,
      },
      last_name: {
        minLength: minLength(2),
        required,
      },
      email: {
        required,
      },
      phone: {
        required,
        isNumber,
      },
      cnpj: {
        minLength: minLength(2),
        required,
      },
      street_address: {
        required,
        isAllowedCharacters,
      },
      address_number: {
        required,
        maxLength: maxLength(10),
        isNumber
      },
      card_city: {
        minLength: minLength(3),
        required,
        isAllowedCharacters,
      },
      card_state: {
        required,
        isAllowedCharacters,
        isText,
      },
      card_postal: {
        minLength: minLength(2),
        required,
        isPostalCode,
      },
      country_name: {
        required,
      },
    },
    creditCardDetails: {
      name: {
        minLength: minLength(2),
        required,
      },
      card_number: {
        minLength: minLength(16),
        maxLength: maxLength(16),
        isNumber,
        required,
      },
      amount: {
        required
      },
      card_type: {
        required
      },
      expiry_month: {
        required
      },
      expiry_year: {
        required
      },
      card_cvc: {
        minLength: minLength(3),
        maxLength: maxLength(3),
        isNumber,
        required,
      }
    },
  },
  async mounted() {
    this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
    this.subscriptions = await getSubscriptions(true);
    this.servicesInCart = await getServicesInCart();
    if (this.servicesInCart.users_count) this.selectUsers = true;
    if (this.servicesInCart.products_available) this.selectCertificates = true;
    if (this.$i18n.locale === 'English') {
      this.paymentOptions = [{ id: 1, mode: 'Credit Card', value: 'CREDIT_CARD' }, { id: 2, mode: 'PIX', value: 'PIX' }, { id: 3, mode: 'Boleto', value: 'BOLETO' }];
    } else {
      this.paymentOptions = [{ id: 1, mode: 'Cartão de Crédito', value: 'CREDIT_CARD' }, { id: 2, mode: 'PIX', value: 'PIX' }, { id: 3, mode: 'Boleto', value: 'BOLETO' }];
    }
  },
  async created() {
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    this.countryList = await getAllCountries();
  },
  methods: {
    changeUsersCount(val) {
      if (val === 'increase') {
        this.servicesInCart.users_count += 1;
        this.servicesInCart.users_purchase_amount = this.servicesInCart.users_count * 299;
      }
      if (val === 'decrease') {
        if (this.servicesInCart.users_count > 0) {
          this.servicesInCart.users_count -= 1;
          this.servicesInCart.users_purchase_amount -= 299;
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Os usuários não podem ser diminuídos ainda mais' : 'Users cannot be decreased further',
            group: 'custom-notification',
          });
        }
      }
    },
    changeCertificatesCount(val) {
      if (val === 'increase') {
        this.servicesInCart.products_available += 5;
        this.servicesInCart.certificates_purchase_amount = (this.servicesInCart.products_available / 5) * 599;
      }
      if (val === 'decrease') {
        if (this.servicesInCart.products_available > 0) {
          this.servicesInCart.products_available -= 5;
          this.servicesInCart.certificates_purchase_amount -= 599;
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Os certificados não podem ser diminuídos ainda mais' : 'Certificates cannot be decreased further',
            group: 'custom-notification',
          });
        }
      }
    },
    updateServices() {
      if (!this.selectCertificates) {
        this.servicesInCart.products_available = 0;
        this.servicesInCart.certificates_purchase_amount = 0;
      }
      if (!this.selectUsers) {
        this.servicesInCart.users_count = 0;
        this.servicesInCart.users_purchase_amount = 0;
      }
    },
    getTotalPrice() {
      const total = this.servicesInCart.users_purchase_amount + this.servicesInCart.certificates_purchase_amount;
      const totalAmount = this.subscriptions.filter((obj) => obj.subscriptionId === 2).length === 0 ? total + 1399 : total;
      this.creditCardDetails.amount = new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(totalAmount);
      return totalAmount.toFixed(2);
    },
    getSubscriptionDetails() {
      return this.subscriptions.filter((obj) => obj.subscriptionId === 2).length === 0;
    },
    disableContinue() {
      if (this.activeHeaderClass === 'Selected Services' && (!this.selectUsers && !this.selectCertificates)) return true;
      if (this.activeHeaderClass === 'Selected Services' && ((this.selectUsers && !this.servicesInCart.users_count) || (this.selectCertificates && !this.servicesInCart.products_available))) return true;
      if (this.activeHeaderClass === 'PaymentMethod' && !this.paymentMethod) {
        return true;
      }
      // if (this.activeHeaderClass === 'PaymentMethod' && this.paymentMethod === 1 && this.$v.creditCardDetails.$invalid) {
      //   return true;
      // }
      if (this.activeHeaderClass === 'BillingInfo') {
        if (this.checkForEmptyOrNullValues || this.$v.userData.$invalid || this.displayEmailErrorMsg) {
          return true;
        }
      }
      return false;
    },
    customLabels(opt) {
      const option = this.countryList.find((x) => x.country_name === opt);
      if (option && Object.keys(option) && Object.keys(option).length) {
        return option.country_name;
      }
      return '';
    },
    emailVal() {
      this.$v.userData.email.$touch();
      const mailformat = /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z-0-9-]+)((\.([a-zA-Z0-9-]){2,63}){1,3})$/; //eslint-disable-line
      this.displayEmailErrorMsg = false;
      if (this.userData.email && !this.userData.email.match(mailformat)) {
        this.displayEmailErrorMsg = true;
        return true;
      }
      return false;
    },
    selectedPaymentMethod(val) {
      this.payment_method_id = val.id;
      this.payment_method_name = val.mode;
      this.payment_method_value = val.value;
    },
    handleActiveTab(tab) {
      this.activeHeaderClass = tab;
    },
    close() {
      this.$router.push('/layout/market-place');
    },
    cnpjMasking(cnpj) {
      this.cnpjValidation = false;
      this.isValidCnpj = '';
      cnpj = cnpj.replace(/\D/g, ''); // Removes everything that is not a digit
      cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2'); // Place dot between second and third digits
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); // Place dot between fifth and sixth digits
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2'); // Puts a slash between the eighth and ninth digits
      cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2'); // Puts a hyphen after the four-digit block
      if (this.userData.cnpj.length === 18) this.cnpjValidation = false;
      this.userData.cnpj = cnpj;
      return cnpj;
    },

    async validateCnpj() {
      this.cnpjInformation = '';
      this.$v.userData.cnpj.$touch();
      if (!this.$v.userData.cnpj.required) {
        this.cnpjValidation = false;
        return;
      }
      if (this.userData.cnpj.length !== 18) {
        this.cnpjValidation = true;
        return;
      }
      if (this.userData.cnpj && this.userData.cnpj.length === 18) {
        // this.loaderStatus = true;
        this.cnpjValidation = false;
        let response = '';
        this.isFailure = true;
        response = await checkCnpj(this.userData.cnpj.replace(/[./-]/g, ''));
        // this.loaderStatus = false;
        if (response.status === 200) {
          this.isFailure = false;
          this.isValidCnpj = 'valid';
        } else {
          const cnpjValid = isValidCNPJ(this.userData.cnpj);
          this.isFailure = false;
          this.isValidCnpj = cnpjValid ? 'valid' : 'invalid';
        }
      }
    },
    changeInPricing(pay) {
      if (pay === true) {
        this.disableProducts = false;
      } else {
        this.disableProducts = true;
      }
    },
    goToNextPage() {
      if (this.activeHeaderClass === 'Selected Services') {
        this.goToConfirmPage();
      } else if (this.activeHeaderClass === 'PaymentMethod') {
        this.goToBillngInfoPage();
        // uncomment later
        // this.activeHeaderClass = 'BillingInfo';
        // this.haveVisitedPaymentPage = true;
      } else if (this.activeHeaderClass === 'BillingInfo') {
        this.goToConfirmationPage();
      }
    },
    async goToConfirmationPage() {
      this.loaderStatus = true;
      this.checkForEmptyOrNullValues = Object.values(this.userData).some((val) => (val === '' || val === null));

      if (this.checkForEmptyOrNullValues || this.$v.userData.$invalid || this.isValidCnpj === 'invalid' || !this.isValidCnpj) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Por favor preencha todos os campos obrigatórios para prosseguir' : 'Please fill out all mandatory fields to proceed.',
          group: 'custom-notification',
        });
      } else {
        this.loaderStatus = false;
        const data = { ...this.userData };
        data.cnpj = data.cnpj.replace(/[./-]/g, '');
        data.card_postal = data.card_postal.replace(/[./-]/g, '');
        const fields = {
          ...data, update_type: 'payment_billing_page', id: this.id
        };
        const response = await updateBillingInfo(fields);
        if (response.status === 204) {
          this.loaderStatus = true;
          this.activeHeaderClass = 'Confirmation';
          this.isVisitedConfirmPage = true;
          this.haveVisitedBillingInfoPage = true;
          // const res = await getPaymentBillingPageData();
          this.getUserData = this.userData;
          this.loaderStatus = false;
        } else {
          let errorData = response.errors;
          if (errorData) {
            errorData = errorData.map((str, index) => (index < errorData.length - 1 ? `${str},` : str));
            errorData = errorData.join(' ');
          } else errorData = this.$i18n.locale === 'Portuguese' ? 'Desculpe, não podemos salvar os detalhes agora' : 'Sorry, we are unable to save the details now.';
          this.loaderStatus = false;
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: errorData,
            group: 'custom-notification',
          });
        }
      }
    },
    async goToBillngInfoPage() {
      this.loaderStatus = true;
      if (!this.paymentMethod) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Por favor selecione um dos métodos de pagamento' : 'Please select one of the payment method',
          group: 'custom-notification',
        });
      } else {
        const data = {
          certificates_count: this.servicesInCart.products_available / 5,
          certificates_purchase_amount: this.servicesInCart.certificates_purchase_amount,
          subscriptionId: this.servicesInCart.subscriptionId,
          payment_mode_id: this.paymentMethod,
          products_available: this.servicesInCart.products_available / 5,
          users_count: this.servicesInCart.users_count,
          users_purchase_amount: this.servicesInCart.users_purchase_amount,
        };
        const response = await addToConfirm(data);
        if (response.status === 204) {
          this.activeHeaderClass = 'BillingInfo';
          this.haveVisitedPaymentPage = true;
          this.loaderStatus = false;
        } else {
          this.loaderStatus = false;
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Desculpe, não podemos prosseguir com sua solicitação' : 'Sorry, we are unable to proceed with your request',
            group: 'custom-notification',
          });
        }
      }
    },
    async goToConfirmPage() {
      this.loaderStatus = true;
      const data = {
        certificates_count: this.servicesInCart.products_available / 5,
        certificates_purchase_amount: this.servicesInCart.certificates_purchase_amount,
        subscriptionId: this.servicesInCart.subscriptionId,
        products_available: this.servicesInCart.products_available / 5,
        users_count: this.servicesInCart.users_count,
        users_purchase_amount: this.servicesInCart.users_purchase_amount,
      };
      const response = await addToConfirm(data);
      if (response.status === 204) {
        this.activeHeaderClass = 'PaymentMethod';
        this.haveVisitedPaymentPage = true;
        this.loaderStatus = false;
      } else {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Desculpe, não podemos prosseguir com sua solicitação' : 'Sorry, we are unable to proceed with your request',
          group: 'custom-notification',
        });
      }
      this.loaderStatus = false;
    },
    showCheckout() {
      $('#checkoutPopup').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async confirm() {
      this.loaderStatus = true;
      const data = {
        certificates_count: this.servicesInCart.products_available / 5,
        certificates_purchase_amount: this.servicesInCart.certificates_purchase_amount,
        subscriptionId: this.servicesInCart.subscriptionId,
        payment_mode_id: this.paymentMethod,
        products_available: this.servicesInCart.products_available / 5,
        users_count: this.servicesInCart.users_count,
        users_purchase_amount: this.servicesInCart.users_purchase_amount,
      };
      const response = await finalCartConfirm(data);
      if (response.status === 201) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Assinatura adicionada com sucesso!' : 'Subscription added successfully!',
          group: 'custom-notification',
        });
        EventBus.$emit('updateCart');
        // EventBus.$emit('updateRoute');
        this.$router.push({ path: '/layout/account-settings?page=services' });
        this.$router.go();
        // }
      } else {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Erro ao adicionar assinatura!' : 'Error while adding subscription!',
          group: 'custom-notification',
        });
      }
    },
    async proceedPayment() {
      this.loaderStatus = true;
      let creditCard = {};
      let creditCardHolderInfo = {};
      const data = {
        billingType: this.payment_method_value,
        value: this.getTotalPrice(),
        dueDate: moment().add(1, 'year').format('YYYY-MM-DD'),
        description: 'Pro Services',
      };
      if (this.payment_method_id === 1) {
        creditCard = {
          number: this.creditCardDetails.card_number.replace(/[./-]/g, ''),
          cardType: this.creditCardDetails.card_type,
          holderName: this.creditCardDetails.name,
          expiryMonth: this.monthList.indexOf(this.creditCardDetails.expiry_month) + 1,
          expiryYear: this.creditCardDetails.expiry_year,
          ccv: parseInt(this.creditCardDetails.card_cvc, 10),
        };
        creditCardHolderInfo = {
          name: `${this.userData.first_name} ${this.userData.last_name}`,
          email: this.userData.email,
          cpfCnpj: this.userData.cnpj.replace(/[./-]/g, ''),
          postalCode: this.userData.card_postal.replace(/[./-]/g, ''),
          address: this.userData.street_address,
          addressNumber: this.userData.address_number,
          city: this.userData.card_city,
          state: this.userData.card_state,
          country: this.userData.country_name,
          phone: this.userData.phone
        };
        data.creditCard = creditCard;
        data.creditCardHolderInfo = creditCardHolderInfo;
      }
      const response = await cartPayment(this.servicesInCart.marketId, data);
      if (response.status === 200) {
        this.loaderStatus = false;
        this.clearNotifcations();
        EventBus.$emit('updateCart');
        this.paymentDetails = response.data;
        $('#checkoutPopup').modal('hide');
        if ([1, 3].includes(this.payment_method_id)) {
          $('#confirmationPaymentPopup').modal({
            backdrop: 'static',
            keyboard: false,
          });
        } else {
          $('#pixPopup').modal({
            backdrop: 'static',
            keyboard: false,
          });
        }
      } else {
        let errorData = response.errors;
        errorData = errorData.map((str, index) => (index < errorData.length - 1 ? `${str},` : str));
        if (errorData) {
          errorData = errorData.map((str, index) => (index < errorData.length - 1 ? `${str},` : str));
          errorData = errorData.join(' ');
        } else errorData = this.$i18n.locale === 'Portuguese' ? 'Desculpe, não podemos prosseguir com sua solicitação.' : 'Sorry, we are unable to proceed with your request.';
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: errorData,
          group: 'custom-notification',
        });
      }
    },
    proceedPix() {
      this.$router.push('/layout/account-settings?page=billing');
    },
    goToServicesPage() {
      this.activeHeaderClass = 'Selected Services';
    },
    cancel() {
      this.$router.push('/layout/market-place');
    },
    goBack() {
      if (this.activeHeaderClass === 'Confirmation') {
        this.activeHeaderClass = 'BillingInfo';
        this.isVisitedConfirmPage = false;
      } else if (this.activeHeaderClass === 'BillingInfo') {
        this.activeHeaderClass = 'PaymentMethod';
        this.haveVisitedBillingInfoPage = false;
      } else if (this.activeHeaderClass === 'PaymentMethod') {
        this.activeHeaderClass = 'Selected Services';
        this.haveVisitedPaymentPage = false;
      } else {
        this.$router.push('/layout/market-place');
      }
    },
    async removeFromCart(id) {
      this.loaderStatus = true;
      const response = await removeFromCartApi(id);
      if (response.status === 204) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Assinatura removida do carrinho!' : 'Subscription removed from cart!',
          group: 'custom-notification',
        });
      } else {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Erro ao remover do carrinho!' : 'Error while removing from cart!',
          group: 'custom-notification',
        });
      }
      EventBus.$emit('updateCart');
      this.servicesInCart = await getServicesInCart();
      if (this.servicesInCart.users_count) this.selectUsers = true;
      if (this.servicesInCart.products_available) this.selectCertificates = true;
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
  },
};
</script>
<style scoped>
.street_address {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
.btn.continue_button[disabled] {
  cursor: not-allowed;
}
.selected-user-certificate {
  font-weight: 600;
  color: #3E3E3E;
}
.pb-12 {
  padding-bottom: 12px;
}
.custom-error-class {
  font-size: 14px;
  line-height: 19px;
  color: #E12D33;
  padding-top: 12px;
  margin: 0px;
}
.custom-success-class{
  color: green;
  margin-top: 0px;
  margin-bottom: 5px;
  padding: 8px;
  font-size: 12px;
  line-height: 16px;
}
.invalid-border {
  border-color: #E12D33 !important;
  margin-bottom: 0px;
}
.entered-data {
  color: #3E3E3E;
  padding-bottom: 64px;
}
.billing-info-header {
  font-size: 18px;
  font-weight: 600;
  color: #3E3E3E;
  padding-top: 50px;
}
.pr-12 {
  padding-right: 12px;
}
.pr-6 {
  padding-right: 6px;
}
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    padding: 4px 40px 4px 11px;
    border: 1px solid #4D4D4D !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 4px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: -13px;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
    margin-bottom: 0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
    padding-left: 0px !important;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding-top: 0px !important;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__option.multiselect__option--highlight span{
  }
  .lang-dropdown .multiselect--above.multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #333333;
    border-radius: 3px;
  }
.pt-12 {
  padding-top: 12px;
}
.field_head:after {
  content: '*';
  font-size: 12px;
  color: #B00505;
  position: relative;
  top: -1px;
  margin-left: 3px;
}
.services-divider {
  border-top: 0.7px solid #B4B4B4;
  margin: 26px 2px 27px 14px;
}
.divider-line {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin-top: 8px;
}
.pt-2 {
  padding-top: 2px;
}
.col-gap-56 {
  display: flex;
  column-gap: 56px;
}

.pr-46{
  padding-right: 46px;
}
.pl-40 {
  padding-left: 40px;
}
.pl-22 {
  padding-left: 22px;
}
.expiation-date {
  color: #3E3E3E;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-bottom: 12px;
}
.field_head {
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;
  padding: 0px 0px 7px 0px;
  margin: 0px;
}
.form-control::placeholder {
  color:  #999999;
}
.form-group input{
  font-weight: 400;
  line-height: 22px;
  font-size: 16px;
  color: #4d4d4d !important;
  padding: 6px 0px 6px 11px;
}
.comn_border {
  background: #ffffff;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 3px;
}
.forProducts{
  color: #3E3E3E;
  font-weight: 600;
}
.ml-11 {
  margin-left: 11px;
}
label>input[type="radio"] {
  display: none;
}

.billing-desc {
  font-size: 18px;
  color: #3E3E3E;
  font-weight: 600;
}

label>input[type="radio"][disabled] {
  cursor: not-allowed;
}

label>input[type="radio"]+*::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-bottom: 4px;
  border-radius: 50%;
  border-style: solid;
  border-width: 2px;
  border-color: #4D4D4D;
}

label>input[type="radio"].radio-btn+*::before {
  margin-right: 16px;
}

label>input[type="radio"]:checked+*::before {
  background: radial-gradient(#00518A 0%, #00518A 46%, transparent 51%, transparent);
  border-color: #00518A;
}
.li-tag-data {
  font-size: 16px;
  line-height: 22px;
}

li.additionalServicesListHeaders {
  list-style: none;
}

li.additionalServicesListHeaders img {
  height: 4px;
  width: 4px;
  margin-right: 7px;
}

.pt-6 {
  padding-top: 6px;
}

.primary-default-text-color {
    color: #3E3E3E;
}

.services .hr-line {
  margin-top: 32px;
  margin-bottom: 27px;
}
.pt-8 {
  padding-top: 8px;
}
.pl-57 {
  padding-left: 57px;
}
.pl-69 {
  padding-left: 69px;
}
.pl-16 {
  padding-left: 16px;
}
.pt-16 {
  padding-top: 16px;
}
.border-grey {
  border: 2px solid #B4B4B4;
}
.border-green {
  border: 2px solid #146600;
}
.services-number {
  border-radius: 25px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  background: #FFFFFF;
  box-shadow:1.62162px 1.62162px 4.05405px rgba(0, 0, 0, 0.12);
  padding: 3px 10px 4px 10px;
  font-size: 18px;
  font-weight: 700;
  color: #3E3E3E;
}
.active_text {
  color: #000000;
}
.visited_text {
  color: #146600;
}
.visited_progress_bar {
  border-top: 4px solid #146600;
}
.active_progress_bar {
  border-top: 4px solid #00518a;
}
.inactive_progress_bar {
  border-top: 4px solid #e6e6e6;
}
.test {
  height: 2px;
  background: red;
}
/* .ms-2 {
  margin-left: 5px;
} */
.view-cart-header {
  padding-top: 36px;
  padding-bottom: 41px;
}
.plr-37 {
  padding-left: 37px;
  padding-right: 38px;
  padding-bottom: 38px;
}
.pl-18 {
  padding-left: 18px;
}
.pr-26 {
  padding-right: 26px;
}
.pr-2 {
  padding-right: 2px;
}
.pl-2 {
  padding-left: 2px !important;
}
.tabs-main {
  /* padding-top:36px;
  padding-bottom:47px; */
  padding: 35px 33px 47px 30px;
}

.tab-stepper {
  padding-left: 1px;
}
.plr-55 {
  padding-left: 55px;
  padding-right: 51px;
  padding-bottom: 20px;
}
.plr-45 {
  padding-left: 45px;
  padding-right: 46px;
  padding-bottom: 20px;
}
.cart-header {
  border: 1px solid #d3d3d3;
  border-top: none;
  padding: 24px 52px 24px 33px;
  background-color: #ffffff !important;
}
.footer {
  padding-top: 23px;
  bottom: 0%;
  padding-right: 32px;
  padding-bottom: 23px;
  /* border-bottom-left-radius: 4px; */
  /* border-bottom-right-radius: 4px; */
  right: 0;
  background-color: #ffffff;
  box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.25);
}
.ml-200 {
  margin-left: 200px;
}
.tabs-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  padding-top: 6px;
}
.cart-main {
  background-color: #f5f5f5;
  height: calc(100vh - 142px);
}
.no-items-in-cart-height {
  height: calc(100vh - 50px) !important;
}
.cart-wrapper {
  background-color: #f5f5f5;
}
.back_button,
.back_button:hover {
  border-radius: 3px;
  border: 1px solid #000001;
  cursor: pointer;
  min-width: 74px;
  min-height: 44px;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  padding:6px 16px ;
  background-color: #ffffff;
  color: #000000;
}
.cancel_button,
.cancel_button:hover {
  border-radius: 3px;
  border: 1px solid #000001;
  cursor: pointer;
  min-width: 90px;
  min-height: 44px;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  padding: 6px 16px;
  background-color: #ffffff;
  color: #000000;
  box-shadow: none;
}
.continue_button,
.continue_button:hover {
  border-radius: 3px;
  border: 1px solid #01518a;
  cursor: pointer;
  min-height: 44px;

  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  padding: 6px 16px;
  background-color: #01518a;
  color: #ffffff !important;
}
.remove_cart_button,
.remove_cart_button:hover {
  border-radius: 3px;
  /* border: 1px solid #000001; */
  cursor: pointer;
  min-width: 173px;
  min-height: 34px;
  font-weight: 600;
  font-size: 16px;
  line-height: 25px;
  padding: 7px 16px 5px 16px;
  background-color: #e6e6e6;
  color: #404040;
  box-shadow: none;
  border: none;
}
.w-112 {
  min-width: 112px;
}
.w-103 {
  min-width: 103px;
}
.items-text {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #3e3e3e;
}

.price-text {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;
}
.total-text {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #333333;
}
.total {
  font-size: 20px;
  font-weight: 600;
  color: #3E3E3E;
}
.col-gap-44 {
  column-gap: 38px;
}
.col-gap-82 {
  column-gap: 82px;
}
.col-gap-80 {
  column-gap: 80px;
}

.nav-tabs {
  border-bottom: none;
  /* background: #ffffff; */
  padding-right: 3px;
}

ul.nav-tabs::after {
  list-style-type: none;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  padding-bottom: 4px;
}

ul li.nav-item {
  cursor: pointer;
  position: relative;
  text-align: center;
}

li.nav-item.active::after {
  position: absolute;
  content: "";
  height: 3px;
  width: 100%;
  background: none;
  left: 3px;
  bottom: 0;
}

.nav-tabs > li.active {
  color: #000000;
  cursor: pointer;
  font-weight: 700 !important;
  border: none;
}

ul.nav-tabs > li {
  margin-right: 40px;
  padding-bottom: 12px;
  font-size: 16px;
}

.nav-tabs .icons img {
  width: 18px;
  height: 18px;
}
.flex-center {
  display: flex;
  align-items: center;
}

.nav-tabs .nav-item {
  font-weight: 300;
  color: #000000;
  font-size: 18px;
  line-height: 25px;
}
.pl-7 {
  padding-left: 7px;
}
.services {
  background: #ffffff;
  border: 1px solid #b3b3b3;
  padding: 16px 24px 50px 24px;
}
.payment-methods {
  background: #ffffff;
  border: 1px solid #b3b3b3;
  padding: 24px 24px 30px 16px;
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 27px;
  color: #3E3E3E;
}
.payment-method {
  font-weight: 600;
}
.payment-header {
  color: #3E3E3E;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-bottom: 26px;
}
.manage-class {
  text-align: right;
  color: #01518A;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}
.cc-card {
  padding-left: 40px;
}

.billing-info {
  background: #ffffff;
  border: 1px solid #b3b3b3;
  padding: 24px 17px 15px 24px;
}
.confirmation-page {
  background: #ffffff;
  border: 1px solid #b3b3b3;
  padding: 18px 42px 24px 31px;
}
.view-all {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #00518a;
}
.upper-line {
  margin: 9px 3px 27px 0px;
  border-top: 0.7px solid #b3b3b3;
}
.divider-line-two {
  margin: 9px 6px 16px 17px;
  border-top: 0.7px solid #b3b3b3;
}
.services-text {
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #3e3e3e;
  padding-left: 14px;
}
.selected-text {
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #333333;
}
.price-details {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;
}
.edit {
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  color: #01518a;
  cursor: pointer;
}
@media (max-width: 1300px) {
  .ml-200 {
    margin-left: 0px;
  }
}
.payPerUseError {
  color: #E12D33;
  font-size: 14px;
  font-weight: 400px;
  padding-left: 48px;
}

.no-items {
  padding-left: 50px;
  height: 100px;
  text-align: center;
}
</style>
